import { ApiKeys } from '@app/constants/api-keys'
import { IEducationGrade } from '@app/interfaces/education/education-grade'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyEducationApi } from '.'
import { IRtkResponse } from '../../types'

export const educationGradeApi = emptyEducationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getEducationGrades: build.query<
      IRtkResponse<IEducationGrade[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/education-grade',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IEducationGrade[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.educationGrade,
                id,
              })),
              { type: ApiKeys.educationGrade, id: 'LIST' },
            ]
          : [{ type: ApiKeys.educationGrade, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.educationGrade, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getEducationGrade: build.query<IEducationGrade, number>({
      query: (id) => ({
        url: `dictionary/api/v1/education-grade/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.educationGrade, id },
      ],
    }),
  }),
})

export const { useGetEducationGradesQuery, useGetEducationGradeQuery } =
  educationGradeApi
